import { createNewLayerFractionalIndex } from "@nova/serializer/src/client/util/fractional_indexing"
import { RootState } from "integrations/redux/rootReducer"

const root = (state: RootState) => state.project.data
export const selectProject = (state: RootState) => state.project.data
export const selectIsProjectLoading = (s: RootState) => !s.project.loaded
export const selectNextFractionalIndex = (s: RootState) => createNewLayerFractionalIndex(root(s))
export const selectProjectHasLoaded = (s: RootState) => s.project.loaded
